import React from 'react';
import { colors } from '../../theme';
import { mono, fmtDay, fmtNum } from './parts';

// Scan history, newest first (SPEC: history row): date and machine, the three numbers in a right-aligned
// mono column with their units, who entered it; a divider where the machine changes. Each row opens
// the scan.
export default function ScanHistory({ scans, whoEntered, onOpen }) {
  return (
    <div>
      {scans.map((s, i) => {
        const newMachine = i > 0 && scans[i - 1].machine !== s.machine;
        return (
          <React.Fragment key={s.id}>
            {newMachine && (
              <div style={{ borderTop: `1px solid ${colors.borderStrong}`, paddingTop: 12, fontSize: 11, color: colors.textMuted }}>{s.machine}</div>
            )}
            <button type="button" onClick={() => onOpen(s)}
              aria-label={`Scan of ${fmtDay(s.measured_on, true)} on ${s.machine}: weight ${fmtNum(s.weight_kg)}, body fat ${fmtNum(s.body_fat_pct)}, muscle ${fmtNum(s.muscle_kg)}. Open.`}
              style={{
                display: 'flex', width: '100%', minHeight: 44, alignItems: 'center', justifyContent: 'space-between', gap: 8,
                padding: '16px 0', background: 'transparent', border: 'none', borderBottom: `1px solid ${colors.border}`,
                color: colors.text, cursor: 'pointer', textAlign: 'left',
              }}>
              <span style={{ minWidth: 0 }}>
                <span style={{ ...mono, display: 'block', fontSize: 14 }}>{fmtDay(s.measured_on)}</span>
                <span style={{ display: 'block', fontSize: 12, color: colors.textMuted, marginTop: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {s.machine} · {whoEntered(s)}
                </span>
              </span>
              <span style={{ display: 'flex', gap: 12, flexShrink: 0 }}>
                {[['kg', s.weight_kg], ['%', s.body_fat_pct], ['kg', s.muscle_kg]].map(([unit, v], k) => (
                  <span key={k} style={{ ...mono, minWidth: 36, textAlign: 'right' }}>
                    <span style={{ display: 'block', fontSize: 14 }}>{fmtNum(v)}</span>
                    <span style={{ display: 'block', fontSize: 10, color: colors.textMuted }}>{v === null || v === undefined ? ' ' : unit}</span>
                  </span>
                ))}
              </span>
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}
